const metadataSlice = {
    navButtons: {
        builder: true,
        preset: true
    }
}

export default metadataSlice
export { metadataSlice }



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastV2/config/components/selection/MetadataSlice/index.js